const ITEMS = ["MATEMATICA", "FISICA", "ONLINE", "A DOMICILIO", "MEDIE", "SUPERIORI"];

const Marquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div className="relative border-y border-slate-800 py-6 overflow-hidden" data-testid="marquee-section" aria-hidden="true">
            <div className="marquee-track flex whitespace-nowrap w-max">
                {[0, 1].map((half) => (
                    <div key={half} className="flex shrink-0">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className={`font-serif italic text-3xl sm:text-4xl px-8 ${i % 2 === 0 ? "text-slate-600" : "outline-text"}`}>
                                    {item}
                                </span>
                                <span className="font-mono text-sky-400/60 text-lg">·</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
